export default __webpack_public_path__ + "static/media/016-account-card.0f8e95a3.svg";